import { Command } from '@/app/common/base/command'

export interface EidasDocumentResult {
    pdfBytes: ArrayBuffer
    hasSavedFormData: boolean
    isSigned: boolean
}

export class GetEidasDocumentCommand extends Command {
    public async run(productActionId: string): Promise<EidasDocumentResult> {
        const response = await this.client.download(
            `/api/actions/${productActionId}/eidas-document`,
            {
                responseType: 'blob',
                timeout: 30000
            },
            true
        )

        const pdfBytes: ArrayBuffer = await response.data.arrayBuffer()
        const hasSavedFormData = response.headers?.['x-has-saved-form-data'] === 'true'
        const isSigned = response.headers?.['x-is-signed'] === 'true'

        return { pdfBytes, hasSavedFormData, isSigned }
    }
}
